import { DEFAULT_MODE, PRIMARY, UTILITY2, makeThemeColor } from '@tornado-rdk/theme';
import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { ICON_COLLECTION } from '@tornado-rdk/icons';
import { getFont, FONT } from '@tornado-rdk/typography';
import { getScreenSize } from '../../utils/sizes';

export const defaultContext = { screenSize: getScreenSize(), colorMode: DEFAULT_MODE };

export const { screenSize = FULL_HD } = defaultContext;

export const colors = {
  text: makeThemeColor(PRIMARY),
  icon: makeThemeColor(UTILITY2),
};

export const ICON_SIZE = {
  WIDTH: {
    [HD]: 16,
    [FULL_HD]: 24,
  },
  HEIGHT: {
    [HD]: 16,
    [FULL_HD]: 24,
  },
};

export const MARGIN = {
  [HD]: 8,
  [FULL_HD]: 12,
};

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize = FULL_HD, colorMode = DEFAULT_MODE } = context;
  const font = getFont(FONT.MADRID_1, screenSize);

  return {
    h: Math.max(ICON_SIZE.HEIGHT[screenSize], font.lineHeight),
    flex: {
      direction: 'row',
    },
    Icon: {
      iconData: {
        picto: {
          name: 'Check',
          collection: ICON_COLLECTION.BASIC,
        },
        viewBox: {
          w: ICON_SIZE.WIDTH[screenSize],
          h: ICON_SIZE.HEIGHT[screenSize],
        },
      },
      color: colors.icon[colorMode],
    },
    Text: {
      text: {
        ...font,
        verticalAlign: 'middle',
        textColor: colors.text[colorMode],
      },
      flexItem: {
        marginLeft: MARGIN[screenSize],
      },
    },
  };
};
